/* Frivolity theme — editorial-first, no modals, no popovers.
   Only the quiet bits of JS a production theme actually needs. */

(function () {
  'use strict';

  /* --- Mobile nav drawer (no overlay, no fixed positioning) --- */
  var toggles = document.querySelectorAll('[data-f-nav-toggle]');
  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      var open = target.hasAttribute('hidden');
      if (open) {
        target.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        target.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* --- Cart count refresh after ajax actions (for app blocks) --- */
  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-f-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { /* quiet */ });
  }

  document.addEventListener('click', function (e) {
    var form = e.target.closest('[data-f-product-form]');
    if (!form) return;
    /* Shopify handles navigation; we just refresh count once the form resolves. */
    setTimeout(refreshCartCount, 1200);
  });

  /* --- Variant selector (no radio buttons, plain selects) --- */
  var productSection = document.querySelector('[data-product-json]');
  if (productSection) {
    var dataEl = document.querySelector('[data-f-product-data]');
    if (dataEl) {
      try {
        var product = JSON.parse(dataEl.textContent);
        var form = productSection.querySelector('[data-f-product-form]');
        var variantInput = productSection.querySelector('[data-f-variant-id]');
        var selects = productSection.querySelectorAll('[data-f-option-index]');

        function currentOptions() {
          var out = [];
          selects.forEach(function (s) {
            var i = parseInt(s.getAttribute('data-f-option-index'), 10);
            out[i] = s.value;
          });
          return out;
        }

        function findVariant() {
          var opts = currentOptions();
          return (product.variants || []).find(function (v) {
            return (v.options || []).every(function (val, i) { return val === opts[i]; });
          });
        }

        function apply() {
          var v = findVariant();
          if (!v || !variantInput) return;
          variantInput.value = v.id;
          var submit = form && form.querySelector('button[type="submit"]');
          if (submit) {
            submit.disabled = !v.available;
            submit.textContent = v.available ? 'Add to cart' : 'Sold out';
          }
        }

        selects.forEach(function (s) { s.addEventListener('change', apply); });
      } catch (err) { /* quiet */ }
    }
  }

  /* --- Try-on deep link: enhance in-app open when on mobile --- */
  var tryonLinks = document.querySelectorAll('[data-f-tryon]');
  tryonLinks.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var ua = navigator.userAgent || '';
      var isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
      if (!isMobile) return; /* let the web link handle it */
      var u = new URL(a.href, window.location.origin);
      var sku = u.searchParams.get('sku') || '';
      var scheme = (window.__FrivolityAppScheme || 'frivolity://') + 'tryon?sku=' + encodeURIComponent(sku);
      /* Attempt scheme, fall back to store link after a moment. */
      var fallback = a.href;
      var t = setTimeout(function () { window.location = fallback; }, 1500);
      window.location = scheme;
      window.addEventListener('pagehide', function () { clearTimeout(t); }, { once: true });
      e.preventDefault();
    });
  });

  /* --- Collection filter/sort auto-submit --- */
  var sort = document.querySelector('[data-f-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      window.location.href = u.toString();
    });
  }

  /* --- Cart quantity inline update (form submit handled by Shopify) --- */
  var qtyInputs = document.querySelectorAll('.f-cart__qty-input');
  qtyInputs.forEach(function (input) {
    var timer;
    input.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var line = parseInt(input.getAttribute('data-f-line'), 10);
        var qty = parseInt(input.value, 10);
        if (!line) return;
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        }).then(function () { window.location.reload(); });
      }, 400);
    });
  });
}());
